import React from 'react'
import { variableStyle } from '../../../utils/styles'
import TriggerArray from './TriggerArray'
import FormCheckboxInfos from './FormCheckboxInfos'
import DefaultValueBox from './DefaultValueBox'
import HideInFormSwitcher from '../../common/HideInFormSwitcher'
import { ItemTypes } from '../../../constants/constants'
import { useStore } from '../../../store/store'

const LeftPart = ({ box, onBlur, form, updateBoxFn }) => {

  return (
    <div className='variable-editor__middle overlay-scroll' style={{
      ...variableStyle["middle"],
      overflow: 'auto'
    }}>
      {box.type !== ItemTypes.QUESTION &&
        <div style={{ marginBottom: 16, fontWeight: "bold" }}>
          <HideInFormSwitcher boxId={box.id} variant='panel' />
        </div>
      }
      <FormCheckboxInfos box={box} onBlur={onBlur} form={form} updateBoxFn={updateBoxFn} />
    </div>
  )
}

const RightPart = ({ box, variablesGroupedByContainer }) => {
  const hasTriggers = useStore(({ triggers }) => triggers[box.id]?.length > 0)
  // Plus de déclencheur sur une question ; on n'affiche le bloc que pour ceux déjà existants.
  const showTriggers = box.type !== ItemTypes.QUESTION || hasTriggers

  return (
    <div className='variable-editor__middle' style={variableStyle["middle"]}>
      <DefaultValueBox box={box} />
      {showTriggers && <TriggerArray box={box} variablesGroupedByContainer={variablesGroupedByContainer} />}
    </div>
  )
}

const FormCheckbox = ({ box, onBlur, form, formPart, variablesGroupedByContainer }) => {

  return (
    <>
      {formPart === 'left' && <LeftPart box={box} onBlur={onBlur} form={form} />}
      {formPart === 'right' && <RightPart box={box} variablesGroupedByContainer={variablesGroupedByContainer} />}
    </>
  )
}

export default FormCheckbox
